import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UsersDto } from 'users-experience-client'

interface SelectedPartner{
  id: string,
  name: string
}

interface UserState {
  currentUser: UsersDto | null;
  userId: string | null;
  selected_partner: SelectedPartner | null;
}

const initialState: UserState = {
  currentUser: null,
  userId: null,
  selected_partner: null
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<UsersDto>) {
      return {
        ...state,
        currentUser: {...state.currentUser, ...action.payload}
      };
    },
    setUserId(state, action: PayloadAction<string>) {
      state.userId = action.payload;
    },
    clearUserId(state) {
      state.userId = null;
    },
    partnerSelected(state,action:PayloadAction<SelectedPartner>){
      state.selected_partner = action.payload;
    },
    clearPartnerSelected(state){
      state.selected_partner = null;
    }

  },
});

export const { setUser, setUserId, clearUserId, partnerSelected, clearPartnerSelected } = userSlice.actions;

export default userSlice.reducer;
